module.exports = __webpack_public_path__ + "static/media/ResultCardiacTrouble.ce592f72.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/ResultCardiacTrouble.jpg
// module id = 511
// module chunks = 0